import React from 'react'
import TablePagination from '@mui/material/TablePagination'

interface PaginationTableProps {
  pagination?: {
    page: number
    totalItem: number
    pageSize: number
  }
  handleChangePage: (_event: unknown, newPage: number) => void
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const PaginationTable: React.FC<PaginationTableProps> = ({
  pagination,
  handleChangePage,
  handleChangeRowsPerPage
}) => {
  return (
    <TablePagination
      rowsPerPageOptions={[5, 10, 25]}
      labelRowsPerPage='Filas por página'
      count={pagination?.totalItem || 0}
      page={pagination?.page || 0}
      rowsPerPage={pagination?.pageSize || 5}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  )
}
